module.exports = __webpack_public_path__ + "static/features-2-84c7b6d30e9368df6dbc39c2b3a2c068.svg";